import React, { useState } from "react";
import { Globe2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";
import { toast } from "sonner";
import { useLanguage } from "../i18n/LanguageContext";
import { LANGUAGES } from "../i18n/translations";

export const LanguageSelector = () => {
  const { language, setPreferredLanguage } = useLanguage();
  const [saving, setSaving] = useState(false);
  const selected = LANGUAGES.find((item) => item.code === language);

  const changeLanguage = async (code) => {
    setSaving(true);
    try { await setPreferredLanguage(code); }
    catch (_) { toast.error("La langue n’a pas pu être enregistrée."); }
    finally { setSaving(false); }
  };

  return (
    <Select value={language} onValueChange={changeLanguage} disabled={saving}>
      <SelectTrigger className="w-[118px] h-9 text-xs" data-testid="language-selector" data-no-translate>
        <Globe2 className="w-4 h-4 mr-1 text-orange-700" />
        <span data-testid="selected-language-label">{selected?.shortLabel}</span>
      </SelectTrigger>
      <SelectContent data-testid="language-selector-menu" data-no-translate>
        {LANGUAGES.map((item) => <SelectItem key={item.code} value={item.code} data-testid={`language-option-${item.code}`}>{item.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};